import React from 'react';

type Props = {
  color?: string;
} & typeof defaultProps;

const defaultProps = {
  color: '#7E7E7E',
};

const SendIconRight = function SendIconRight({ color }: Props) {
  return (
    <svg width="17px" height="14px" viewBox="0 0 17 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Shape</title>
      <g id="Client-Prototype" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Person_Share" transform="translate(-970.000000, -379.000000)" fill={color} fillRule="nonzero">
          <g id="Group-18-Copy" transform="translate(945.687561, 239.497801)">
            <g id="noun-comments-1155637" transform="translate(25.000000, 103.231520)">
              <path d="M12.0625,41.1666667 L12.875,41.1666667 C13.7724627,41.1666667 14.5,41.891539 14.5,42.7857143 L14.5,49.8809524 C14.5,50.7751277 13.7724627,51.5 12.875,51.5 L3.125,51.5 C2.22753728,51.5 1.5,50.7751277 1.5,49.8809524 L1.5,42.7857143 C1.5,41.891539 2.22753728,41.1666667 3.125,41.1666667 L3.9375,41.1666667 C4.38623136,41.1666667 4.75,41.5291028 4.75,41.9761905 C4.75,42.4232781 4.38623136,42.7857143 3.9375,42.7857143 L3.125,42.7857143 L3.125,49.8809524 L12.875,49.8809524 L12.875,42.7857143 L12.0625,42.7857143 C11.6137687,42.7857143 11.25,42.4232781 11.25,41.9761905 C11.25,41.5291028 11.6137687,41.1666667 12.0625,41.1666667 Z M7.38273449,35.7830997 C7.53175162,35.6098081 7.75300512,35.5 8,35.5 C8.24699488,35.5 8.46824838,35.6098081 8.61726551,35.7830997 L10.8726213,38.0301941 C11.1899223,38.3463328 11.1899223,38.858895 10.8726213,39.1750337 C10.5553203,39.4911724 10.0408737,39.4911724 9.72357274,39.1750337 L8.8125,38.2672981 L8.8125,46.0238095 C8.8125,46.4708971 8.44873132,46.8333333 8,46.8333333 C7.55126868,46.8333333 7.1875,46.4708971 7.1875,46.0238095 L7.1875,38.2672981 L6.27642722,39.1750337 C5.95912623,39.4911724 5.44467969,39.4911724 5.1273787,39.1750337 C4.81007771,38.858895 4.81007771,38.3463328 5.1273787,38.0301941 L7.38273449,35.7830997 Z" id="Shape" transform="translate(8.000000, 43.500000) rotate(-270.000000) translate(-8.000000, -43.500000) " />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

SendIconRight.defaultProps = defaultProps;

export default SendIconRight;
